import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { logout } from 'redux/auth/auth-operations';
import { fetchContacts, addContact, deleteContact } from './contacts-operations';

const handlePending = state => {
  state.contacts.isLoading = true;
};

const handleRejected = (state, action) => {
  state.contacts.isLoading = false;
  state.contacts.error = action.payload;
};

const contactsSlice = createSlice({
  name: 'contacts',
  initialState: {
    contacts: { items: [], isLoading: false, error: null },
    filter: '',
  },
  reducers: {
    setFilter(state, action) {
      state.filter = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      //FETCH ALL//
      .addCase(fetchContacts.fulfilled, (state, action) => {
        state.contacts.isLoading = false;
        state.contacts.error = null;
        state.contacts.items = action.payload;
      })
      .addCase(fetchContacts.pending, handlePending)
      .addCase(fetchContacts.rejected, handleRejected)
      //ADD CONTACT//
      .addCase(addContact.pending, handlePending)
      .addCase(addContact.fulfilled, (state, action) => {
        state.contacts.isLoading = false;
        state.contacts.error = null;
        state.contacts.items.push(action.payload);
        toast.success(`Contact "${action.payload.name}" added!`);
      })
      .addCase(addContact.rejected, handleRejected)
      //DELETE CONTACT//
      .addCase(deleteContact.pending, handlePending)
      .addCase(deleteContact.fulfilled, (state, action) => {
        state.contacts.isLoading = false;
        state.contacts.error = null;
        state.contacts.items = state.contacts.items.filter(
          contact => contact.id !== action.payload.id
        );
        toast.warning(`Contact "${action.payload.name}" has been deleted!`);
      })
      .addCase(deleteContact.rejected, handleRejected)
      //LOGOUT//
      .addCase(logout.fulfilled, (state,action)=>{
        state.contacts.isLoading = false;
        state.contacts.error = null;
        state.contacts.items = [];
        state.filter='';
      })
  },
});

export const { setFilter } = contactsSlice.actions;
export const contactsReducer = contactsSlice.reducer;
